import f3tch from 'f3tch';

import profile from '../../api/profiles/json.profile.api';

const normalizeList = (data) => {
  if (Array.isArray(data)) return data;
  if (data?.results) return data.results;
  return [];
};

export default async (query = {}) => {
  const data = await f3tch('/branches/reduced_deductible_rates/')
    .profile(profile())
    .query(query)
    .get();
  return normalizeList(data);
};
